// 🔐 accounts (09-30): the /explore top-bar door (Nina's pick 09-30: option C,
// a person icon with no word; its name shows on hover like the +). Signed in,
// it becomes a small circle with your first letter and a short menu.
// Lives INSIDE ExploreChat's `.xc`, so it borrows that bar's tokens
// (--ink / --line / --row-hover) and its .xc-tip tooltip; the ring is its own
// .ms-door class (never .xc-plus: the /explore gate finds the + by that class).
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACCOUNT_CSS } from './accountStyles';
import { useAccount } from './useAccount';
import { openSignIn } from './accountEvents';
import { signOut, maskEmail, initialOf } from './accountState';

const PersonIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <circle cx="8" cy="5.6" r="2.7" />
    <path d="M2.8 14c.8-2.7 2.8-4 5.2-4s4.4 1.3 5.2 4" strokeLinecap="round" />
  </svg>
);

export default function AccountDoor() {
  const account = useAccount();
  const navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!menu) return undefined;
    const onDown = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setMenu(false); };
    const onKey = (e) => { if (e.key === 'Escape') setMenu(false); };
    document.addEventListener('pointerdown', onDown);
    window.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('pointerdown', onDown); window.removeEventListener('keydown', onKey); };
  }, [menu]);

  if (account.status === 'signed_out') {
    return (
      <>
        <style>{ACCOUNT_CSS}</style>
        <button type="button" className="ms-door" onClick={() => openSignIn({ source: 'explore_bar' })} aria-label="Sign in">
          <PersonIcon /><span className="xc-tip" aria-hidden="true">Sign in</span>
        </button>
      </>
    );
  }
  if (account.status !== 'signed_in') return null;

  const counts = (account.summary && account.summary.counts) || {};
  const rooms = (account.summary && account.summary.rooms) || [];
  const go = (path) => (e) => { e.preventDefault(); setMenu(false); navigate(path); };
  // A disclosure (button + list), not an ARIA menu: Tab walks into it, and it
  // closes when focus leaves it, on Escape, or on a click outside.
  const onBlur = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.relatedTarget)) setMenu(false); };
  return (
    <div className="ms-me-wrap" ref={wrapRef} onBlur={onBlur}>
      <style>{ACCOUNT_CSS}</style>
      <button type="button" className="ms-me" onClick={() => setMenu((m) => !m)} aria-expanded={menu} aria-controls="ms-account-menu" aria-label="Your account">
        {initialOf(account.account && account.account.email)}
      </button>
      {menu && (
        <div className="ms-menu" id="ms-account-menu">
          <div className="ms-menu-who"><b>Signed in</b><small className="ph-no-capture">{maskEmail(account.account && account.account.email)}</small></div>
          <a href="/account" onClick={go('/account')}>Your spaces <span>{rooms.length}</span></a>
          <a href="/account#ais" onClick={go('/account#ais')}>Your AIs <span>{counts.agents || 0}</span></a>
          <button type="button" className="ms-quiet" onClick={() => { setMenu(false); signOut(); }}>Sign out</button>
        </div>
      )}
    </div>
  );
}
